import List from 'components/List/List';
import Title from 'components/Title/Title';
import withCountry from 'enhancers/withCountry';
import withLanguageState, { WithLanguageProps } from 'enhancers/withLanguageState';
import withRulesPageQuery, { WithRulesPageQueryProps } from 'enhancers/withRulesPageQuery';
import withRulesState from 'enhancers/withRulesState';
import * as React from 'react';
import Placeholder from 'react-placeholder';
import { compose } from 'redux';
import styled from 'styled-components';

type Props = WithRulesPageQueryProps & WithLanguageProps;

const enhance = compose(
  withLanguageState,
  withCountry,
  withRulesPageQuery
);

const Rules = withRulesState(List);

// export const RulesPage: React.SFC<Props> = props => {
export class RulesPage extends React.Component<Props> {
  public render() {
    const { props } = this;
    const hasLists = !props.loading && props.data && props.data.fetch.Country;
    const listBackground =
      hasLists &&
      props.data &&
      props.data.fetch.Common.Rules &&
      props.data.fetch.Common.Rules.Lists &&
      props.data.fetch.Common.Rules.Lists.QuestionsBackground
        ? props.data.fetch.Common.Rules.Lists.QuestionsBackground
        : '#fff';

    const menuColor =
      hasLists &&
      props.data &&
      props.data.fetch.Common.Rules &&
      props.data.fetch.Common.Rules.Lists &&
      props.data.fetch.Common.Rules.Lists.NumberBackground
        ? props.data.fetch.Common.Rules.Lists.NumberBackground
        : '#eeeeee';

    const activeColor =
      hasLists &&
      props.data &&
      props.data.fetch.Common.Rules &&
      props.data.fetch.Common.Rules.Lists &&
      props.data.fetch.Common.Rules.Lists.NumberActiveBackground
        ? props.data.fetch.Common.Rules.Lists.NumberActiveBackground
        : '#333333';
    const background =
      !props.loading &&
      props.data &&
      props.data.fetch.Common.Rules &&
      props.data.fetch.Common.Rules.BackgroundColor
        ? props.data.fetch.Common.Rules.BackgroundColor
        : '#ffffff';

    return (
      <Container style={{ background }}>
        <TopContainer>
          <Top
            style={{
              color:
                !props.loading &&
                props.data &&
                props.data.fetch.Common.Rules &&
                props.data.fetch.Common.Rules.TitleColor
                  ? props.data.fetch.Common.Rules.TitleColor
                  : '#000000'
            }}
          >
            <Placeholder
              showLoadingAnimation={true}
              ready={!props.loading}
              rows={1}
            >
              <StyledTitle>
                {!props.loading &&
                  props.data &&
                  props.getText(props.data.fetch.Country.RulesPage.Header)}
              </StyledTitle>
            </Placeholder>
            <Subtitle>
              <Placeholder
                showLoadingAnimation={true}
                ready={!props.loading}
                rows={1}
              >
                {!props.loading &&
                  props.data &&
                  props.getText(props.data.fetch.Country.RulesPage.Subtitle)}
              </Placeholder>
            </Subtitle>
          </Top>
        </TopContainer>

        <Placeholder
          showLoadingAnimation={true}
          ready={!props.loading}
          type="rect"
          style={{ height: 300 }}
        >
          {!props.loading && props.data ? (
            <Rules
              menu={{
                activeColor,
                background: listBackground,
                color: menuColor
              }}
              background={listBackground}
              items={props.data.fetch.Country.RulesPage.Rules.map(item => ({
                content: props.getText(item.Content),
                title: props.getText(item.Title)
              }))}
            />
          ) : (
            []
          )}
        </Placeholder>
      </Container>
    );
  }
}

const Subtitle = styled.div`
  margin-bottom: 55px;
`;

const StyledTitle = styled(Title)`
  text-align: center;
  margin-top: 0;
`;

const Container = styled.div`
  padding-top: 25px;
  transition: 0.25s ease all;
`;

const TopContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const Top = styled.div`
  padding: 15px;
  max-width: 900px;
`;

export default enhance(RulesPage);



// WEBPACK FOOTER //
// ./src/pages/RulesPage/RulesPage.tsx